// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Pervasives = require("bs-platform/lib/js/pervasives.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Json$BwaxMobile = require("../../../../bwax-js/ml/utils/json.bs.js");
var Plate$BwaxMobile = require("../../../../bwax-js/ml/plate.bs.js");
var Lang_eval$BwaxMobile = require("../../../../bwax-js/ml/lang/lang_eval.bs.js");
var DefaultTheme = require("bwax-ui/defaultTheme");
var ColorTypes$BwaxMobile = require("../../../re/ColorTypes.bs.js");
var Widget_common$BwaxMobile = require("./widget_common.bs.js");
var Runtime_common$BwaxMobile = require("../../../../bwax-js/ml/lang/mod/runtime_common.bs.js");

var module_name = "Nivo";

var src = "\n\nmodule " + (String(module_name) + ";\n\nimport Element exposing (Rule, Element);\n\ntype alias ColorModifier = \n  { brighter: Float \n  , darker: Float \n  , opacity: Float\n  }\n;\n\ntype ColorSetting = \n  | Theme String \n  | From String ~ColorModifier\n  | Simply Color\n;\n\ntype Shape = \n  | Dot ~{ size: Int, padding: Int, stagger: Bool }\n  | Line ~{ spacing: Int, rotation: Float, lineWidth: Int }\n  | Square ~{ size: Int, padding: Int, stagger: Bool }\n;\n\ntype alias Margin = { top: Int, right: Int, bottom: Int, left: Int };\n\ntype Definition =\n  | Pattern ~{ shape: Shape!,  background: Color, color: Color } -- 颜色和背景默认为 inherit\n  -- | Gradient (List ~{ offset: Int, opacity: Float, color: Color }) -- 颜色默认为 inherit\n;\n\n\n\ntype alias Legend = \n  { anchor: String      -- \"bottom\" by default\n  , direction: String   -- \"row\"\n  , itemWidth: Int      -- 80\n  , itemHeight: Int     -- 16\n  , itemsSpacing: Int   -- 8\n  , justify: Bool       -- False\n  , translateX: Int   \n  , translateY: Int\n  , symbolSize: Int\n  , itemDirection: String \n  }\n;\n\ntype MotionConfig = \n  | Preset String \n  -- | Custom  -- Custom 部分等 BwaxUI 继承了 React-spring 之后再说\n;\n\ntype alias Axis = \n  { orient: String\n  , tickSize: Int\n  , tickPadding: Int \n  , tickRotation: Int \n  , legend: String \n  , legendOffset: Int \n  , legendPosition: String\n  }\n;\n\n\ntype ValueScale = Linear | SymLog;\n\n--- Pie\ntype alias PieDatum = \n  { id: String!\n  , value: Float!\n  , color: Color  -- 如果数据给了 color，图标将不适用 color theme，而是使用数据的 color.\n  } \n;\n\ntype alias PieNode = \n  { id: String, label: String, value: Float }\n;\n\ntype alias PieConfig msg = \n  { data: List ~PieDatum !\n  , width: Int!\n  , height: Int!\n\n  , valueFormat: String\n\n  , startAngle: Float\n  , endAngle: Float\n\n  , innerRadius: Float  -- percentage\n  , padAngle: Float\n\n  , cornerRadius: Int -- px\n\n  , sortByValue: Bool -- 这个其实不一定需要，因为 sorting 可以在外面做\n\n  , margin: ~Margin --px \n\n  , colorScheme: String\n  , borderColor: ColorSetting\n  , borderWidth: Int\n\n  , defs: List (Definition, String)\n  , fill: List (PieDatum -> Bool, String)  -- match and id\n\n  , enableRadialLabels: Bool\n  \n  , radialLabel: PieNode -> String -- by default use id\n  , radialLabelsSkipAngle: Float \n  , radialLabelsLinkOffset: Int\n  , radialLabelsLinkDiagonalLength: Int\n  , radialLabelsLinkHorizontalLength: Int\n  , radialLabelsTextXOffset: Int\n  , radialLabelsLinkStrokeWidth: Int\n  , radialLabelsTextColor: ColorSetting\n  , radialLabelsLinkColor: ColorSetting\n  \n  , enableSliceLabels: Bool\n\n  , sliceLabel: PieDatum -> String \n  , sliceLabelsSkipAngle: Float\n  , sliceLabelsRadiusOffset: Float\n  , sliceLabelsTextColor: ColorSetting\n\n\n  -- Interactivity\n  , isInteractive: Bool\n  , onMouseEnter: PieNode -> msg\n  , onMouseLeave: PieNode -> msg\n  , onClick: PieNode -> msg \n  --, tooltip: PieNode -> Element msg -- 不一定能实现\n\n  , legends: List ~Legend\n  }\n;\n\npie: List (Rule msg) -> ~ PieConfig msg -> Element msg = external;\n\n\n-- Line\ntype alias LineDatum x y =\n  { id: String\n  , data: List (x, y)\n  }\n;\n\ntype alias LineNode x y = \n  { x: x\n  , y: y \n  , serieId: String \n  , serieColor: Color\n  , color: Color\n  , index: Int\n  }\n;\n\ntype LineScale =\n  | PointBased \n  | LinearBased ~{ stacked: Bool, min: Float, max: Float } \n;\n\n\n\n\ntype alias LineConfig x y msg = \n  { data: List (LineDatum x y)!\n  , width: Int!\n  , height: Int! \n  , margin: Margin\n\n  , xFormat: String\n  , yFormat: String \n  , xScale: LineScale\n  , yScale: LineScale\n  -- style\n  , curve: String\n  , colorTheme: String\n  , lineWidth: Int \n  \n  , enableArea: Bool\n  , areaConfig: ~{ baselineValue: y, opacity: Float, blendMode: String }\n\n  -- 下面这两个有用吗？\n  , defs: List (Definition, String)\n  , fill: List (LineDatum x y -> Bool, String)  -- match and id\n\n  -- points \n  , enablePoints: Bool\n  , pointSize: Int \n  , pointColor: ColorSetting\n  , pointBorderWidth: Int \n  , pointBorderColor: ColorSetting\n\n  , enbablePointLabel: Bool\n  , pointLabel: LineDatum x y -> String\n\n  -- grid & axes\n  , enableGridX: Bool\n  , enableGridY: Bool \n\n  , axisTop: ~Axis\n  , axisRight: ~Axis\n  , axisLeft: ~Axis\n  , axisBottom: ~Axis\n\n  -- interaction \n  , isInteractive: Bool\n  , onMouseEnter: LineNode x y -> msg\n  , onMouseLeave: LineNode x y -> msg\n  , onClick: LineNode x y -> msg \n  , tooltip: LineNode x y -> Element msg -- 不一定能实现\n\n  -- , useMesh  -- always true please\n  , enableSlices: String -- x y\n\n  , enableCrosshair: Bool \n  , crosshairType: String\n\n  --\n  , legends: List Legend\n\n  , animate: Bool\n  , motionConfig: MotionConfig\n\n  }\n;\n\n-- TODO 还没支持\n-- line: List (Rule msg) -> ~ LineConfig x y msg -> Element msg = external;\n\n\n--- bar \n\ntype alias BarDatum =\n  { group: String\n  , data: List (String, Float)\n  }\n;\n\ntype alias BarNode = \n  { id: String\n  , value: String\n  , group: String\n  , groupIndex: Int\n  , color: Color\n  }\n;  \n\ntype GroupMode = Stacked | Grouped;\ntype Layout = Horizontal | Vertical;\n\n\ntype alias BarConfig msg = \n  { data: List BarDatum!\n  , width: Int!\n  , height: Int!\n  -- keys and indexBy are automatically determined.\n  , groupMode: GroupMode\n  , layout: Layout\n  , valueScale: ValueScale\n  , reverse: Bool\n  , minValue: Float \n  , maxValue: Float \n  , padding: Float -- padding between bars, in ratio\n  , innerPadding: Int -- padding between grouped/starked parts, in px\n  , magin: Margin \n\n  -- style\n  , colorTheme: String\n  -- , colorBy: BarDatum -> Color\n  , borderRadious: Int \n  , borderWidth: Int \n  , borderColor: ColorSetting\n\n  , defs: List (Definition, String)\n  , fill: List ({id: String, value: Float } -> Bool, String)  -- match and id\n\n  -- label\n  , enableValue: Bool\n  , label: BarNode -> String\n  , labelFormat: String \n  , labelSkipWidth: Int \n  , labelSkipHeight: Int \n  , labelTextColor: ColorSetting\n\n  -- grid & axes\n  , enableGridX: Bool\n  , enableGridY: Bool \n\n  , axisTop: ~Axis\n  , axisRight: ~Axis\n  , axisLeft: ~Axis\n  , axisBottom: ~Axis\n\n  -- interactivity \n  , isInteractive: Bool\n\n  , onMouseEnter: BarNode -> msg\n  , onMouseLeave: BarNode -> msg\n  , onClick: BarNode -> msg \n  , tooltip: BarNode -> Element msg -- 不一定能实现\n  \n  -- legends\n  , legends: List Legend\n\n  -- motion\n  , animate: Bool \n  , motionStiffness: Int\n  , motionDamping: Int \n\n  }\n;\n\n\n-- TODO 还没支持\n-- bar: List (Rule msg) -> BarConfig msg -> Element msg = external\n;\n\n-- radar\n\n\n-- scatter plot\n\n\n-- calendar\n\n\n");

function stackup(key, decode, source, base) {
  var mv = Plate$BwaxMobile.$$Option.and_then(decode, Plate$BwaxMobile.List.assoc(key, source));
  if (mv !== undefined) {
    return Pervasives.$at(base, /* :: */[
                /* tuple */[
                  key,
                  Caml_option.valFromOption(mv)
                ],
                /* [] */0
              ]);
  } else {
    return base;
  }
}

function color_to_json(c) {
  return Caml_option.some(DefaultTheme.themeColor(undefined, ColorTypes$BwaxMobile.toString(Widget_common$BwaxMobile.make_color(c))));
}

function string_to_json(v) {
  return Plate$BwaxMobile.$$Option.map((function (prim) {
                return prim;
              }), Lang_eval$BwaxMobile.as_string(v));
}

function float_to_json(v) {
  return Plate$BwaxMobile.$$Option.map((function (prim) {
                return prim;
              }), Lang_eval$BwaxMobile.as_float(v));
}

function bool_to_json(v) {
  return Plate$BwaxMobile.$$Option.map((function (prim) {
                return prim;
              }), Lang_eval$BwaxMobile.as_bool(v));
}

function color_setting_to_json(v) {
  var match = v[0];
  if (typeof match === "number" || match.tag !== /* V_tagged */6) {
    return ;
  } else {
    switch (match[0]) {
      case "From" :
          var match$1 = match[1];
          if (match$1) {
            var match$2 = match$1[0][0];
            if (typeof match$2 === "number" || match$2.tag !== /* V_literal */5) {
              return ;
            } else {
              var match$3 = match$2[0];
              if (typeof match$3 === "number" || match$3.tag !== /* String */2) {
                return ;
              } else {
                var match$4 = match$1[1];
                if (match$4) {
                  var match$5 = match$4[0][0];
                  if (typeof match$5 === "number" || !(match$5.tag === /* V_record */2 && !match$4[1])) {
                    return ;
                  } else {
                    var mods = match$5[0];
                    var get_value = function (key) {
                      return Plate$BwaxMobile.$$Option.map((function (v) {
                                    return /* tuple */[
                                            key,
                                            v
                                          ];
                                  }), Plate$BwaxMobile.$$Option.and_then(float_to_json, Plate$BwaxMobile.List.assoc(key, mods)));
                    };
                    var m_darker = get_value("darker");
                    var m_brighter = get_value("brighter");
                    var m_opacity = get_value("opacity");
                    var modifiers = Curry._1(Plate$BwaxMobile.List.to_array, Plate$BwaxMobile.List.keep_map((function (x) {
                                return x;
                              }), /* :: */[
                              m_darker,
                              /* :: */[
                                m_brighter,
                                /* :: */[
                                  m_opacity,
                                  /* [] */0
                                ]
                              ]
                            ]));
                    return {
                            from: match$3[0],
                            modifiers: modifiers
                          };
                  }
                } else {
                  return ;
                }
              }
            }
          } else {
            return ;
          }
      case "Simply" :
          var match$6 = match[1];
          if (match$6 && !match$6[1]) {
            return Caml_option.some(DefaultTheme.themeColor(undefined, ColorTypes$BwaxMobile.toString(Widget_common$BwaxMobile.make_color(match$6[0]))));
          } else {
            return ;
          }
      case "Theme" :
          var match$7 = match[1];
          if (match$7) {
            var match$8 = match$7[0][0];
            if (typeof match$8 === "number" || match$8.tag !== /* V_literal */5) {
              return ;
            } else {
              var match$9 = match$8[0];
              if (typeof match$9 === "number" || !(match$9.tag === /* String */2 && !match$7[1])) {
                return ;
              } else {
                return {
                        theme: match$9[0]
                      };
              }
            }
          } else {
            return ;
          }
      default:
        return ;
    }
  }
}

function margin_to_json(margin) {
  var match = margin[0];
  if (typeof match === "number" || match.tag !== /* V_record */2) {
    return ;
  } else {
    var margins = match[0];
    var obj = stackup("bottom", float_to_json, margins, stackup("right", float_to_json, margins, stackup("left", float_to_json, margins, stackup("top", float_to_json, margins, /* [] */0))));
    return Caml_option.some(Js_dict.fromList(obj));
  }
}

function legends_to_json(legends) {
  var legend_to_json = function (legend) {
    var match = legend[0];
    if (typeof match === "number" || match.tag !== /* V_record */2) {
      return ;
    } else {
      var binds = match[0];
      var obj = stackup("itemDirection", string_to_json, binds, stackup("symbolSize", float_to_json, binds, stackup("itemsSpacing", float_to_json, binds, stackup("itemHeight", float_to_json, binds, stackup("itemWidth", float_to_json, binds, stackup("translateY", float_to_json, binds, stackup("translateX", float_to_json, binds, stackup("justify", bool_to_json, binds, stackup("direction", string_to_json, binds, stackup("anchor", string_to_json, binds, /* [] */0))))))))));
      return Caml_option.some(Js_dict.fromList(obj));
    }
  };
  var match = legends[0];
  if (typeof match === "number" || match.tag !== /* V_list */1) {
    return ;
  } else {
    return Caml_option.some(Curry._1(Plate$BwaxMobile.List.to_array, Plate$BwaxMobile.List.keep_map(legend_to_json, match[0])));
  }
}

function defs_to_json(v) {
  var extract_shape_config = function (c) {
    if (c !== undefined) {
      var match = c[0];
      if (typeof match === "number" || match.tag !== /* V_tagged */6) {
        return /* [] */0;
      } else {
        var match$1 = match[1];
        if (match$1) {
          var match$2 = match$1[0][0];
          if (typeof match$2 === "number" || !(match$2.tag === /* V_record */2 && !match$1[1])) {
            return /* [] */0;
          } else {
            var shape = match$2[0];
            var patternType;
            switch (match[0]) {
              case "Dot" :
                  patternType = "patternDots";
                  break;
              case "Line" :
                  patternType = "patternLines";
                  break;
              default:
                patternType = "patternSquares";
            }
            return Plate$BwaxMobile.List.foldl((function (acc, param) {
                          var k = param[0];
                          var mv = Plate$BwaxMobile.$$Option.and_then(param[1], Plate$BwaxMobile.List.assoc(k, shape));
                          if (mv !== undefined) {
                            return Pervasives.$at(acc, /* :: */[
                                        /* tuple */[
                                          k,
                                          Caml_option.valFromOption(mv)
                                        ],
                                        /* [] */0
                                      ]);
                          } else {
                            return acc;
                          }
                        }), /* :: */[
                        /* tuple */[
                          "type",
                          patternType
                        ],
                        /* [] */0
                      ], /* :: */[
                        /* tuple */[
                          "size",
                          float_to_json
                        ],
                        /* :: */[
                          /* tuple */[
                            "padding",
                            float_to_json
                          ],
                          /* :: */[
                            /* tuple */[
                              "stagger",
                              bool_to_json
                            ],
                            /* :: */[
                              /* tuple */[
                                "spacing",
                                float_to_json
                              ],
                              /* :: */[
                                /* tuple */[
                                  "rotation",
                                  float_to_json
                                ],
                                /* :: */[
                                  /* tuple */[
                                    "lineWidth",
                                    float_to_json
                                  ],
                                  /* [] */0
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]);
          }
        } else {
          return /* [] */0;
        }
      }
    } else {
      return /* [] */0;
    }
  };
  var def_to_json = function (def) {
    var match = def[0];
    if (typeof match === "number" || match.tag) {
      return ;
    } else {
      var match$1 = match[0];
      if (match$1) {
        var match$2 = match$1[0][0];
        if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged */6 && match$2[0] === "Pattern")) {
          return ;
        } else {
          var match$3 = match$2[1];
          if (match$3) {
            var match$4 = match$3[0][0];
            if (typeof match$4 === "number" || !(match$4.tag === /* V_record */2 && !match$3[1])) {
              return ;
            } else {
              var match$5 = match$1[1];
              if (match$5) {
                var match$6 = match$5[0][0];
                if (typeof match$6 === "number" || match$6.tag !== /* V_literal */5) {
                  return ;
                } else {
                  var match$7 = match$6[0];
                  if (typeof match$7 === "number" || !(match$7.tag === /* String */2 && !match$5[1])) {
                    return ;
                  } else {
                    var patternConfig = match$4[0];
                    var with_shape = extract_shape_config(Plate$BwaxMobile.List.assoc("shape", patternConfig));
                    var get_color = function (name) {
                      return Plate$BwaxMobile.$$Option.with_default("inherit", Plate$BwaxMobile.$$Option.and_then(color_to_json, Plate$BwaxMobile.List.assoc(name, patternConfig)));
                    };
                    var background = get_color("background");
                    var color = get_color("color");
                    var cl = Pervasives.$at(/* :: */[
                          /* tuple */[
                            "id",
                            match$7[0]
                          ],
                          /* :: */[
                            /* tuple */[
                              "color",
                              color
                            ],
                            /* :: */[
                              /* tuple */[
                                "background",
                                background
                              ],
                              /* [] */0
                            ]
                          ]
                        ], with_shape);
                    return Caml_option.some(Js_dict.fromList(cl));
                  }
                }
              } else {
                return ;
              }
            }
          } else {
            return ;
          }
        }
      } else {
        return ;
      }
    }
  };
  var match = v[0];
  var ret;
  ret = typeof match === "number" || match.tag !== /* V_list */1 ? /* [] */0 : Plate$BwaxMobile.List.keep_map(def_to_json, match[0]);
  return Caml_option.some(Curry._1(Plate$BwaxMobile.List.to_array, ret));
}

function pie_fill_to_json(fill) {
  var predicate_to_json = function (p) {
    return (function (j) {
        var match = Plate$BwaxMobile.$$Option.and_then(Runtime_common$BwaxMobile.json_to_value, Json$BwaxMobile.get_field("data", j));
        if (match !== undefined) {
          return Plate$BwaxMobile.$$Option.with_default(false, Lang_eval$BwaxMobile.as_bool(Lang_eval$BwaxMobile.apply_value(undefined, p, match, Runtime_common$BwaxMobile.nt)));
        } else {
          return Runtime_common$BwaxMobile.invalid_args("pie_fill_to_json");
        }
      });
  };
  var pair_to_json = function (pair) {
    var match = pair[0];
    if (typeof match === "number" || match.tag) {
      return ;
    } else {
      var match$1 = match[0];
      if (match$1) {
        var match$2 = match$1[1];
        if (match$2) {
          var match$3 = match$2[0][0];
          if (typeof match$3 === "number" || match$3.tag !== /* V_literal */5) {
            return ;
          } else {
            var match$4 = match$3[0];
            if (typeof match$4 === "number" || !(match$4.tag === /* String */2 && !match$2[1])) {
              return ;
            } else {
              return Caml_option.some(Js_dict.fromList(/* :: */[
                              /* tuple */[
                                "match",
                                predicate_to_json(match$1[0])
                              ],
                              /* :: */[
                                /* tuple */[
                                  "id",
                                  match$4[0]
                                ],
                                /* [] */0
                              ]
                            ]));
            }
          }
        } else {
          return ;
        }
      } else {
        return ;
      }
    }
  };
  var match = fill[0];
  if (typeof match === "number" || match.tag !== /* V_list */1) {
    return ;
  } else {
    return Caml_option.some(Curry._1(Plate$BwaxMobile.List.to_array, Plate$BwaxMobile.List.keep_map(pair_to_json, match[0])));
  }
}

function pie_node_to_string_to_json(fn) {
  return Caml_option.some((function (j) {
                var match = Runtime_common$BwaxMobile.json_to_value(j);
                if (match !== undefined) {
                  return Plate$BwaxMobile.$$Option.with_default("", Lang_eval$BwaxMobile.as_string(Lang_eval$BwaxMobile.apply_value(undefined, fn, match, Runtime_common$BwaxMobile.nt)));
                } else {
                  return Runtime_common$BwaxMobile.invalid_args("pie_node_to_string_to_json");
                }
              }));
}

function pie_node_tagger(tagger) {
  return (function (j) {
            var match = Runtime_common$BwaxMobile.json_to_value(j);
            if (match !== undefined) {
              return Lang_eval$BwaxMobile.apply_value(undefined, tagger, match, Runtime_common$BwaxMobile.nt);
            } else {
              return Runtime_common$BwaxMobile.invalid_args("pie_node_tagger");
            }
          });
}

function as_plain(decode, v) {
  return Plate$BwaxMobile.$$Option.map((function (v) {
                return /* Plain */Block.__(0, [v]);
              }), Curry._1(decode, v));
}

function as_tagger(decode, v) {
  return Plate$BwaxMobile.$$Option.map((function (v) {
                return /* Tagger */Block.__(1, [v]);
              }), Curry._1(decode, v));
}

function pie_data_to_json(data) {
  var match = data[0];
  if (typeof match === "number" || match.tag !== /* V_list */1) {
    return ;
  } else {
    var from_pie_datum = function (param) {
      var match = param[0];
      if (typeof match === "number" || match.tag !== /* V_record */2) {
        return ;
      } else {
        var ds = match[0];
        var obj = stackup("color", color_to_json, ds, stackup("value", float_to_json, ds, stackup("id", string_to_json, ds, /* [] */0)));
        return Caml_option.some(Js_dict.fromList(obj));
      }
    };
    return Caml_option.some(Curry._1(Plate$BwaxMobile.List.to_array, Plate$BwaxMobile.List.keep_map(from_pie_datum, match[0])));
  }
}

function get_pie_config(config) {
  return stackup("legends", (function (param) {
                return as_plain(legends_to_json, param);
              }), config, stackup("onClick", (function (param) {
                    return as_tagger(pie_node_tagger, param);
                  }), config, stackup("onMouseLeave", (function (param) {
                        return as_tagger(pie_node_tagger, param);
                      }), config, stackup("onMouseEnter", (function (param) {
                            return as_tagger(pie_node_tagger, param);
                          }), config, stackup("isInteractive", (function (param) {
                                return as_plain(bool_to_json, param);
                              }), config, stackup("sliceLabelsTextColor", (function (param) {
                                    return as_plain(color_setting_to_json, param);
                                  }), config, stackup("sliceLabelsRadiusOffset", (function (param) {
                                        return as_plain(float_to_json, param);
                                      }), config, stackup("sliceLabelsSkipAngle", (function (param) {
                                            return as_plain(float_to_json, param);
                                          }), config, stackup("sliceLabel", (function (param) {
                                                return as_plain(pie_node_to_string_to_json, param);
                                              }), config, stackup("enableSliceLabels", (function (param) {
                                                    return as_plain(bool_to_json, param);
                                                  }), config, stackup("radialLabelsLinkColor", (function (param) {
                                                        return as_plain(color_setting_to_json, param);
                                                      }), config, stackup("radialLabelsTextColor", (function (param) {
                                                            return as_plain(color_setting_to_json, param);
                                                          }), config, stackup("radialLabelsLinkStrokeWidth", (function (param) {
                                                                return as_plain(float_to_json, param);
                                                              }), config, stackup("radialLabelsTextXOffset", (function (param) {
                                                                    return as_plain(float_to_json, param);
                                                                  }), config, stackup("radialLabelsLinkHorizontalLength", (function (param) {
                                                                        return as_plain(float_to_json, param);
                                                                      }), config, stackup("radialLabelsLinkDiagonalLength", (function (param) {
                                                                            return as_plain(float_to_json, param);
                                                                          }), config, stackup("radialLabelsLinkOffset", (function (param) {
                                                                                return as_plain(float_to_json, param);
                                                                              }), config, stackup("radialLabelsSkipAngle", (function (param) {
                                                                                    return as_plain(float_to_json, param);
                                                                                  }), config, stackup("radialLabel", (function (param) {
                                                                                        return as_plain(pie_node_to_string_to_json, param);
                                                                                      }), config, stackup("enableRadialLabels", (function (param) {
                                                                                            return as_plain(bool_to_json, param);
                                                                                          }), config, stackup("fill", (function (param) {
                                                                                                return as_plain(pie_fill_to_json, param);
                                                                                              }), config, stackup("defs", (function (param) {
                                                                                                    return as_plain(defs_to_json, param);
                                                                                                  }), config, stackup("borderWidth", (function (param) {
                                                                                                        return as_plain(float_to_json, param);
                                                                                                      }), config, stackup("borderColor", (function (param) {
                                                                                                            return as_plain(color_setting_to_json, param);
                                                                                                          }), config, stackup("colorScheme", (function (param) {
                                                                                                                return as_plain(string_to_json, param);
                                                                                                              }), config, stackup("margin", (function (param) {
                                                                                                                    return as_plain(margin_to_json, param);
                                                                                                                  }), config, stackup("sortByValue", (function (param) {
                                                                                                                        return as_plain(bool_to_json, param);
                                                                                                                      }), config, stackup("cornerRadius", (function (param) {
                                                                                                                            return as_plain(float_to_json, param);
                                                                                                                          }), config, stackup("padAngle", (function (param) {
                                                                                                                                return as_plain(float_to_json, param);
                                                                                                                              }), config, stackup("innerRadius", (function (param) {
                                                                                                                                    return as_plain(float_to_json, param);
                                                                                                                                  }), config, stackup("endAngle", (function (param) {
                                                                                                                                        return as_plain(float_to_json, param);
                                                                                                                                      }), config, stackup("startAngle", (function (param) {
                                                                                                                                            return as_plain(float_to_json, param);
                                                                                                                                          }), config, stackup("valueFormat", (function (param) {
                                                                                                                                                return as_plain(string_to_json, param);
                                                                                                                                              }), config, stackup("height", (function (param) {
                                                                                                                                                    return as_plain(float_to_json, param);
                                                                                                                                                  }), config, stackup("width", (function (param) {
                                                                                                                                                        return as_plain(float_to_json, param);
                                                                                                                                                      }), config, stackup("data", (function (param) {
                                                                                                                                                            return as_plain(pie_data_to_json, param);
                                                                                                                                                          }), config, /* [] */0))))))))))))))))))))))))))))))))))));
}

function get_number(name, default_value, config) {
  var match = Plate$BwaxMobile.List.assoc(name, config);
  if (match !== undefined) {
    var match$1 = match;
    if (match$1.tag) {
      return default_value;
    } else {
      return Plate$BwaxMobile.$$Option.with_default(default_value, Js_json.decodeNumber(match$1[0]));
    }
  } else {
    return default_value;
  }
}

function fail(name) {
  throw [
        Lang_eval$BwaxMobile.Eval_exn,
        module_name + ("." + (name + ": Invalid Arguments"))
      ];
}

var externals_vals_000 = /* tuple */[
  "pie",
  Widget_common$BwaxMobile.pack_element_func(2, (function (param) {
          if (param) {
            var match = param[0][0];
            if (typeof match === "number" || match.tag !== /* V_list */1) {
              return Runtime_common$BwaxMobile.invalid_args("pie");
            } else {
              var match$1 = param[1];
              if (match$1) {
                var match$2 = match$1[0][0];
                if (typeof match$2 === "number" || !(match$2.tag === /* V_record */2 && !match$1[1])) {
                  return Runtime_common$BwaxMobile.invalid_args("pie");
                } else {
                  var rules = Widget_common$BwaxMobile.raw_to_rules(match[0]);
                  var c = get_pie_config(match$2[0]);
                  var width = get_number("width", 300.0, c);
                  var height = get_number("height", 300.0, c);
                  return /* Nivo */Block.__(19, [
                            rules,
                            "pie",
                            width,
                            height,
                            c
                          ]);
                }
              } else {
                return Runtime_common$BwaxMobile.invalid_args("pie");
              }
            }
          } else {
            return Runtime_common$BwaxMobile.invalid_args("pie");
          }
        }))
];

var externals_vals = /* :: */[
  externals_vals_000,
  /* [] */0
];

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  externals_vals
];

var command_handlers = /* [] */0;

exports.module_name = module_name;
exports.src = src;
exports.stackup = stackup;
exports.color_to_json = color_to_json;
exports.string_to_json = string_to_json;
exports.float_to_json = float_to_json;
exports.bool_to_json = bool_to_json;
exports.color_setting_to_json = color_setting_to_json;
exports.margin_to_json = margin_to_json;
exports.legends_to_json = legends_to_json;
exports.defs_to_json = defs_to_json;
exports.pie_fill_to_json = pie_fill_to_json;
exports.pie_node_to_string_to_json = pie_node_to_string_to_json;
exports.pie_node_tagger = pie_node_tagger;
exports.as_plain = as_plain;
exports.as_tagger = as_tagger;
exports.pie_data_to_json = pie_data_to_json;
exports.get_pie_config = get_pie_config;
exports.get_number = get_number;
exports.fail = fail;
exports.externals_vals = externals_vals;
exports.command_handlers = command_handlers;
exports.externals = externals;
/* src Not a pure module */
